const reportsWithMultiLocationsFilter = [
    'staff-commission-sales',
    'staff-sales-and-performance',
    'conversion-by-staff-basic',
    'conversion-by-staff-advanced',
    'conversion-by-location'
];

export default reportsWithMultiLocationsFilter;
